/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { BarcodeData, TaskDataString } from '../../../../../../../models/task.model';
import { Logger, LogService } from '@epg/angular-base-lib';
import { CustomDateFormatService } from '../../../../../../../services/custom-date-format/custom-date-format.service';

@Component({
  selector: 'app-barcode-item',
  templateUrl: './barcode-item.component.html',
  styleUrls: ['./barcode-item.component.scss'],
  standalone: false
})
export class BarcodeItemComponent implements OnInit {
  @Input() barcodeItem: BarcodeData = new BarcodeData(
    new TaskDataString(''),
    new TaskDataString(''),
    new TaskDataString('')
  );

  private log: Logger;

  constructor(
    logService: LogService,
    public customDateFormatService: CustomDateFormatService
  ) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    this.log.debug(this.barcodeItem);
  }
}
